import React, { forwardRef, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { getIcons } from '_helpers';

/**
 * Composant Personnalisé: Autocomplete simple
 */
export const CustomAutocomplete = forwardRef(({
        name,
        label,
        options,
        noOptionsText = 'Aucune correspondance',
        onInputChange,
        onChange,
        onClear,
        disablePortal = true,
        endAdornmentIconSrc = 'clearOutlinedGrey',
        endAdornmentIconAlt = 'icon return',
        isSubmitting = false,
        sxOverrides = {},
        defaultValue = '',
        value = null,
        disabled = false
    }, ref) => {

    const [ uniqId, setUniqId ] = useState(1);

    /**
     * Gestion des changments
     * @param {*} event 
     * @param {*} newValue 
     */
    const handleChange = (event, newValue) => {
        const selectedId = newValue.id ?? newValue ?? null;
        onChange(selectedId);
    };
    const handleInputChange = (event, newInputValue, reason) => {
        if (reason === 'reset') {
            onInputChange(newInputValue);
        }
    };
    const handleClear = () => {
        setUniqId(Math.floor(Math.random() * 10000))
        onClear();
    };

    return (
        <Autocomplete
            disabled={disabled}
            key={uniqId}
            noOptionsText={noOptionsText}
            onInputChange={handleInputChange}
            onChange={handleChange}
            name={name}
            ref={ref}
            disablePortal={disablePortal}
            options={options}            
            sx={{
                "& button[title='Clear']": {
                    visibility: "hidden"
                },
                ...sxOverrides
            }}            
            isOptionEqualToValue={(option, value) => {
                if (value === "" || value === null || value === undefined) return false;
                if (typeof value === 'string' || typeof value === 'number') {
                    return option === value ;
                }
                return option?.id === value?.id;
            }}
            getOptionLabel={(option) => option?.label?.toString() ?? option?.toString() ?? ""}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    className='form-control'
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <InputAdornment position="end">
                                <button
                                    onClick={handleClear}
                                    type="button"
                                    disabled={isSubmitting}
                                    className=""
                                >
                                    <img
                                        src={getIcons(endAdornmentIconSrc)}
                                        alt={endAdornmentIconAlt}
                                        className="btn-custom-icon"
                                    />
                                </button>
                            </InputAdornment>
                        ),
                        style: {
                            paddingRight: '8px', 
                        },
                    }}
                />
            )}
            value={value}
            defaultValue={defaultValue}
        />
    );
});